import type { Extension } from "@tiptap/react";
import { StarterKit } from "@tiptap/starter-kit";

export const CustomStarterKitExtension = (): Extension => {
  return StarterKit.configure({
    paragraph: {
      HTMLAttributes: {
        class: "editor-paragraph-block"
      }
    },
    heading: {
      HTMLAttributes: {
        class: "editor-heading-block"
      }
    },
    bulletList: {
      HTMLAttributes: {
        class: "list-disc pl-7"
      }
    },
    orderedList: {
      HTMLAttributes: {
        class: "list-decimal pl-7"
      }
    },
    listItem: {
      HTMLAttributes: {
        class: "space-y-2"
      }
    },
    codeBlock: false,
    blockquote: false,
    horizontalRule: false
  });
};
